import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookies'
import 'vue-datetime/dist/vue-datetime.css'

// vue-cookies
Vue.use(VueCookies)
Vue.$cookies.config('8h')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
